import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Repository } from 'typeorm';
import { CommmentsEntity } from './comments.entity';
import { AllCommentsResponseModel, CommentsResponseModel } from './dto/comments-response-module';
import { CommentsDTO, GetCommentsByPostId, PaginationDto, } from './dto/comments.dto';

@Injectable()
export class CommentsService {
    constructor(
        @InjectRepository(CommmentsEntity)
        private commentsRepository: Repository<CommmentsEntity>,
       
    ) {}

    async createComment(queryParams, commentsDTO:CommentsDTO, request: Request): Promise<CommentsResponseModel> {
        const response = new CommentsResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saveComment = await this.commentsRepository.save(commentsDTO);
                if(saveComment) {
                    response.status = true;
                    response.data   = saveComment;
                    response.statusCode = 50000;
                    response.internalMessage = 'Comment posted successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Comment not posted')
                }
            } else {
                const saveComment = await this.commentsRepository.save(commentsDTO);
                if(saveComment) {
                    response.status = true;
                    response.data   = saveComment;
                    response.statusCode = 50000;
                    response.internalMessage = 'Comment posted successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Comment not posted')
                }
            }            
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getCommentsByPostId(pageDto:PaginationDto, postId,request:Request): Promise<AllCommentsResponseModel> {
        const response = new AllCommentsResponseModel();
        try {
            if(pageDto.apiVersion == 1) {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                }
                const cmntData = await this.commentsRepository.find({
                    relations:["user","user.profile"],
                    where: {postId:postId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(cmntData) {
                    const finData: any[] = [];
                    cmntData.map((c) => {
                        finData.push({
                            Id: c.Id,
                            postId: c.postId,
                            userId: c.userId,
                            comment: c.comment,
                            createdAt: c.createdAt,
                            firstName:c.user.profile.firstName,
                            profilePic:c.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${c.user.profile.profilePic}` : ''
                        })
                    })
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                if(!pageDto.skip || pageDto.skip == null) {
                    pageDto.skip = 0;
                }
                const cmntData = await this.commentsRepository.find({
                    relations:["user","user.profile"],
                    where: {postId:postId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(cmntData) {
                    const finData: any[] = [];
                    cmntData.map((c) => {
                        finData.push({
                            Id: c.Id,
                            postId: c.postId,
                            userId: c.userId,
                            comment: c.comment,
                            createdAt: c.createdAt,
                            firstName:c.user.profile.firstName,
                            profilePic:c.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${c.user.profile.profilePic}` : ''
                        })
                    })
                    response.status = true;
                    response.data = finData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getPostCmtsCount(postId) {
        try {
            const cmtCount = await getConnection()
            .createQueryBuilder()
            .select("count(*) as cnt")
            .from(CommmentsEntity, "Comments")
            .where('post_id=:da', { da: postId })
            .orderBy('created_at','ASC')
            .getRawOne();
            if(cmtCount) {
                return cmtCount;
            } else { 
                return null; 
            }
        } catch (error) {
            throw error;
        }
    }
    
}
